module.exports = __webpack_public_path__ + "img/Checkbox.9babe72b.svg";